import { useCallback } from 'react';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useLeaderBoardLeave = () => {
    const send = useGenericSend();

    return useCallback(async ({ leaderboardId }: Types.ILeaderBoardLeaveRequestData) => {
        const response = await send<Types.ILeaderBoardLeaveRequestData, Types.ILeaderBoardLeaveResponseData>({
            ID: 71007,
            leaderboardId,
            responses: [71008, 71009],
            description: 'Leave from Leaderboard'
        });

        return response;
    }, [send]);
};
